// components/NenhumSped.tsx
import React from 'react';
import {
  Alert,
  Typography,
  Paper,
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Container,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircleOutline';

const NenhumSped: React.FC = () => {
  const itensAnalise = [
    'Recomendações de alíquotas corretas por código de barras',
    'Divergências no cadastro de produtos por código de barras',
    'Divergências no cadastro de produtos por NCM',
    'Totalizadores gerais para cada Sped Fiscal Importado, como Notas Fiscais, Produtos, Perdas, etc.',
    'Relatórios gráficos e detalhados de análise de ICMS',
    'Créditos e Débitos Totais de ICMS',
    'Créditos e Débitos de ICMS por produto',
    'Créditos e Débitos Totais de ICMS por Estrutura Mercadológica',
    'Créditos e Débitos Totais por NCM'
  ];

  return (
    <Container sx={{ mt: 4 }}>
      <Paper elevation={3} sx={{ borderRadius: 3, p: 4 }}>
        <Alert severity="info" sx={{ mb: 2 }}>
          Seja bem-vindo ao <strong>TribuNex</strong> — Sistema de gestão tributária e análise do SPED Fiscal.
        </Alert>

        <Alert severity="warning" sx={{ mb: 4 }}>
          Para começar, <strong>importe um arquivo</strong> para visualizar os dados e obter insights detalhados.
        </Alert>

        <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: '#444' }}>
          Após a importação do SPED Fiscal e da Estrutura Mercadológica, você terá acesso a:
        </Typography>

        <List dense>
          {itensAnalise.map((item, index) => (
            <ListItem key={index} sx={{ py: 1 }}>
              <ListItemIcon>
                <CheckCircleIcon color="primary" />
              </ListItemIcon>
              <ListItemText primary={item} />
            </ListItem>
          ))}
        </List>
      </Paper>
    </Container>
  );
};

export default NenhumSped;
